function getConvertCurrency(exchangeRates) {
  return (opts) => {
    var _a;
    const { amount, fromCurrency, toCurrency } = opts;
    const exchangeRate = fromCurrency === toCurrency ? 1 : (_a = exchangeRates[toCurrency]) == null ? void 0 : _a[fromCurrency];
    if (exchangeRate === void 0) {
      return void 0;
    }
    const result = amount / exchangeRate;
    return { exchangeRate, result };
  };
}
export {
  getConvertCurrency
};
